module.exports = __webpack_public_path__ + "static/media/market-climber.16e56808.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/market-climber.jpg
// module id = 2629
// module chunks = 0